var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5715 3.21882C13.6663 -0.686004 7.33448 -0.686439 3.42878 3.21882C-0.476478 7.12408 -0.476043 13.4559 3.42878 17.3616C7.33404 21.266 13.6658 21.2664 17.5715 17.3616C21.4764 13.4559 21.4759 7.12452 17.5715 3.21882ZM11.8041 14.6381C11.8041 15.3585 11.2202 15.9424 10.4997 15.9424C9.77929 15.9424 9.19537 15.3585 9.19537 14.6381V9.42063C9.19537 8.70018 9.77929 8.11627 10.4997 8.11627C11.2202 8.11627 11.8041 8.70018 11.8041 9.42063V14.6381ZM10.4767 7.19104C9.72537 7.19104 9.2245 6.65886 9.24015 6.00189C9.2245 5.31319 9.72537 4.7971 10.4919 4.7971C11.2589 4.7971 11.7441 5.31363 11.7602 6.00189C11.7597 6.65886 11.2593 7.19104 10.4767 7.19104Z",
    fill: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i_icon.324272994eec1b17642776c3806bb973.svg";
export { ForwardRef as ReactComponent };